import Vue from 'vue';
import ToolTipPanel from 'components/widgets/ToolTipPanel/ToolTipPanel.vue';
import ChartToolTipBody from 'components/widgets/ChartToolTipBody/ChartToolTipBody.vue';
import FormatUtils from 'src/utils/formatters';
export default Vue.extend({
    components: { ToolTipPanel, ChartToolTipBody },
    props: {
        label: { type: [String, Number], required: false, default: '(No Value)' },
        nps: { type: Number, required: false, default: null },
        records: { type: Number, required: false, default: null },
        frequency: { type: Number, required: false, default: null },
        promoters: { type: Number, required: false, default: null },
        detractors: { type: Number, required: false, default: null },
        passives: { type: Number, required: false, default: null },
        positive: { type: Number, required: false, default: null },
        negative: { type: Number, required: false, default: null },
        mixed: { type: Number, required: false, default: null },
        neutral: { type: Number, required: false, default: null },
        aggregationValue: { type: Number, required: false, default: null },
        aggregationLabel: { type: String, required: false, default: '(No Value)' }
    },
    computed: {
        hasNPS() { return this.nps !== null && this.promoters !== null && this.detractors !== null && this.passives !== null; },
        hasSentiment() { return this.positive !== null && this.negative !== null && this.mixed !== null && this.neutral !== null; },
        hasAggregation() { return this.aggregationValue !== null && this.aggregationLabel !== null; }
    },
    methods: {
        number: FormatUtils.number,
        decimalAsPercent: FormatUtils.decimalAsPercent,
        formatNPS: FormatUtils.formatNPS,
    },
});
